var exports = {
  "MT": "DesktopSettingsView.module__searchContainer___c3J1b0",
  "FY": "DesktopSettingsView.module__backButtonContainer___c3J1b0",
  "j2": "DesktopSettingsView.module__backIcon___c3J1b0",
  "wV": "DesktopSettingsView.module__noResults___c3J1b0",
  "Gn": "DesktopSettingsView.module__tabLabel___c3J1b0",
  "fC": "DesktopSettingsView.module__badgeContainer___c3J1b0",
  "tM": "DesktopSettingsView.module__sectionLabelWithBadge___c3J1b0",
  "bS": "DesktopSettingsView.module__legalLinks___c3J1b0",
  "z8": "DesktopSettingsView.module__footerContent___c3J1b0",
  "el": "DesktopSettingsView.module__legalLink___c3J1b0",
  "Ic": "DesktopSettingsView.module__footerSpacer___c3J1b0",
  "Ij": "DesktopSettingsView.module__fullWidth___c3J1b0",
  "QM": "DesktopSettingsView.module__breadcrumbTitle___c3J1b0",
  "Yr": "DesktopSettingsView.module__breadcrumbButton___c3J1b0",
  "BV": "DesktopSettingsView.module__breadcrumbChevron___c3J1b0",
  "rV": "DesktopSettingsView.module__breadcrumbCurrent___c3J1b0",
};

module.exports = exports;
